import { Component, ViewChild} from '@angular/core';
import { Chart } from 'chart.js';
import { WizardComponent } from 'ng2-archwizard/dist';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})



export class AppComponent {
  @ViewChild(WizardComponent) public wizard: WizardComponent;

  chart: Chart;
  chart_data = [];
  chart_labels = [];
  chart_color = [];
  filedDay = 0;
  filedDayTime = 0;
  filedCalc = 0;
  filedMinute = 0;
  filedHour = 0;
  searchDay = 0;
  searchDayTime = 0;
  searchCalc = 0;
  searchMinute = 0;
  searchHour = 0;
  copyDay = 0;
  copyDayTime = 0;
  copyCalc = 0;
  copyMinute = 0;
  copyHour = 0;
  anzMember = 0;
  anzMemberTime = 0;
  anzMemberCalc = 0;
  anzMemberMinute = 0;
  anzMemberHour = 0;
  anzRestore = 0;
  anzRestoreTime = 0;
  anzRestoreCalc = 0;
  anzRestoreMinute = 0;
  anzRestoreHour = 0;
  sumCalc = 0;
  sumMinute = 0;
  sumHour = 0;
  anzSquare = 0;
  monthSquarceCost = 0;
  anzSquareCalc = 0;
  shipping = 0;
  printPrice = 0;
  anzPrint = 0;
  printCalc = 0;
  photocopyCalc= 0;
  photocopyPrice= 0;
  sumRessource = 0;
  anzPersonal = 0;
  personalPrice = 0;
  sumPersonal = 0;
  anzActivity = 0;
  activityPrice = 0;
  sumActivity =  0;
  sumCost = 0;
  period = 0;
  invest = 0;
  month = 0;
  price = 0;
  isShowInvest = false;
  isShowPeriod = false;


  constructor() {
    // Defaultwerte setzen
    this.restart();
  }

  calcResult() {
    this.sumPersonal = (((this.sumCalc / 100) * this.anzPersonal) / 60) * this.personalPrice;
    this.sumActivity = (((this.sumCalc / 100) * this.anzActivity) / 60) * this.activityPrice;

    this.sumCost = this.sumRessource + this.sumActivity + this.sumPersonal;
  }

  calcRessource() {
    this.anzSquareCalc = this.anzSquare * this.monthSquarceCost;
    this.photocopyCalc = this.copyDay * this.photocopyPrice * 20;
    this.printCalc =  this.printPrice * this.anzPrint * 20;
    this.sumRessource = this.anzSquareCalc + this.shipping + this.photocopyCalc + this.printCalc;

    this.calcResult();
  }

  calcTimes() {
    // Berehcnung für Ablegen
    this.filedCalc = this.filedDay * (this.filedDayTime - 0.5) * 20;
    this.filedHour = Math.floor(this.filedCalc / 60);
    this.filedMinute = this.filedCalc % 60;

    // Berechnung für Suchen
    this.searchCalc = this.searchDay * (this.searchDayTime - 0.5) * 20;
    this.searchHour = Math.floor(this.searchCalc / 60);
    this.searchMinute = this.searchCalc % 60;

    // Berechnung für Kopieren
    this.copyCalc = this.copyDay * (this.copyDayTime - 0.5) * 20;
    this.copyHour = Math.floor(this.copyCalc / 60);
    this.copyMinute = this.copyCalc % 60;

    // Berechnung für Verteilen
    this.anzMemberCalc = this.anzMember * (this.anzMemberTime - 0.5) * 20;
    this.anzMemberHour = Math.floor(this.anzMemberCalc / 60);
    this.anzMemberMinute = this.anzMemberCalc % 60;

    // Berechnung für Wiederherstellung
    this.anzRestoreCalc = this.anzRestore * (this.anzRestoreTime);
    this.anzRestoreHour = Math.floor(this.anzRestoreCalc / 60);
    this.anzRestoreMinute = this.anzRestoreCalc % 60;

    this.sumCalc = this.filedCalc + this.searchCalc + this.copyCalc + this.anzMemberCalc;
    this.sumHour = Math.floor(this.sumCalc / 60);
    this.sumMinute = this.sumCalc % 60;

    // wenn sich zeiten ändern ändert sich auch das Gesamtergebnis
    this.calcResult();
  }


  showInvest() {
    this.isShowInvest = true;
    this.isShowPeriod = false;

    if (this.invest > 0 && this.sumCost > 0) {
      this.month = this.invest / this.sumCost;
    } else {
      this.month = null;
    }

    this.chart_data = [];
    this.chart_labels = [];
    this.chart_color = [];
    let chart_loop = 0;
    let chart_price = 0 - this.invest;
    while (chart_loop <= this.month * 2) {
      this.chart_labels.push(chart_loop);
      this.chart_data.push(chart_price);
      this.chart_color.push(chart_price <= 0 ? 'red' : 'green');
      chart_loop ++;
      chart_price = chart_price + this.sumCost;
    }

    this.wizard.navigation.goToStep(5);
    if (this.chart != null) {
      this.chart.destroy();
    }
    this.drawChart();
  }

  showPeriod() {
    this.isShowInvest = false;
    this.isShowPeriod = true;

    this.price = this.sumCost * this.period;

    this.chart_data = [];
    this.chart_labels = [];
    this.chart_color = [];
    let chart_loop = 0;
    let chart_price = 0 - this.price;
    while (chart_loop <= this.period * 2) {
      this.chart_labels.push(chart_loop);
      this.chart_data.push(chart_price);
      this.chart_color.push(chart_price <= 0 ? 'red' : 'green');
      chart_loop ++;
      chart_price = chart_price + this.sumCost;
    }

    this.wizard.navigation.goToStep(5);
    if (this.chart != null) {
      this.chart.destroy();
    }
    this.drawChart();
  }

  drawChart() {
    // adding custom chart type
    Chart.defaults.multicolorLine = Chart.defaults.line;
    Chart.controllers.multicolorLine = Chart.controllers.line.extend({
      draw: function (ease) {
        let
          startIndex = 0;
        const
          meta = this.getMeta(),
          points = meta.data || [],
          colors = this.getDataset().colors,
          area = this.chart.chartArea,
          originalDatasets = meta.dataset._children
            .filter(function (data) {
              return !isNaN(data._view.y);
            });

        function _setColor(newColor, metadata) {
          metadata.dataset._view.borderColor = newColor;
        }

        if (!colors) {
          Chart.controllers.line.prototype.draw.call(this, ease);
          return;
        }

        for (let i = 2; i <= colors.length; i++) {
          if (colors[i - 1] !== colors[i]) {
            _setColor(colors[i - 1], meta);
            meta.dataset._children = originalDatasets.slice(startIndex, i);
            meta.dataset.draw();
            startIndex = i - 1;
          }
        }

        meta.dataset._children = originalDatasets.slice(startIndex);
        meta.dataset.draw();
        meta.dataset._children = originalDatasets;

        points.forEach(function (point) {
          point.draw(area);
        });
      }
    });

    this.chart = new Chart('canvas', {
      // The type of chart we want to create
      type: 'multicolorLine',
      // The data for our dataset
      data: {
        labels: this.chart_labels,
        datasets: [{
          label: 'My First dataset',
          // borderColor: 'rgb(255, 99, 132)',
          data: this.chart_data,
          // first color is not important
          colors: this.chart_color
        }]
      },

      // Configuration options go here
      options: {
        legend: {
          display: false
        },
        scales: {
          yAxes: [{
            scaleLabel: {
              display: true,
              labelString: 'Einsparung'
            }
          }],
          xAxes: [{
            scaleLabel: {
              display: true,
              labelString: 'Monate'
            }
          }],
        }
      },
    });
  }

  chartColor() {
    console.log('chartColor');
    return this.chart_data.map((values) => values < 0 ? 'red' : 'green');
  }

  restart() {
    // setzen Defaultwerte
    this.filedDay = 0;
    this.filedDayTime = 3;
    this.filedCalc = 0;
    this.filedMinute = 0;
    this.filedHour = 0;
    this.searchDay = 0;
    this.searchDayTime = 5;
    this.searchCalc = 0;
    this.searchMinute = 0;
    this.searchHour = 0;
    this.copyDay = 0;
    this.copyDayTime = 5;
    this.copyCalc = 0;
    this.copyMinute = 0;
    this.copyHour = 0;
    this.anzMember = 0;
    this.anzMemberTime = 30;
    this.anzMemberCalc = 0;
    this.anzMemberMinute = 0;
    this.anzMemberHour = 0;
    this.anzRestore = 0;
    this.anzRestoreTime = 30;
    this.anzRestoreCalc = 0;
    this.anzRestoreMinute = 0;
    this.anzRestoreHour = 0;
    this.sumCalc = 0;
    this.sumMinute = 0;
    this.sumHour = 0;


    this.anzSquare = 0;
    this.monthSquarceCost = 15;
    this.anzSquareCalc = 0;

    this.shipping = 0;

    this.printPrice = 0.1;
    this.anzPrint = 0;
    this.printCalc = 0;

    this.photocopyCalc = 0.0;
    this.photocopyPrice = 0.1;

    this.sumRessource = 0.00;

    this.anzPersonal = 5;
    this.personalPrice = 25;
    this.sumPersonal = 0;
    this.anzActivity = 5;
    this.activityPrice = 25;
    this.sumActivity =  0;

    this.sumCost = 0;
    this.period = 0;
    this.invest = 0;

    this.isShowInvest = false;
    this.isShowPeriod = false;

    // initialie berechnung starten
    this.calcTimes();
    this.calcRessource();
  }
}



// WEBPACK FOOTER //
// C:/Users/newan/PhpstormProjects/GromnitzaRoi/src/app/app.component.ts